import { IoCallSharp, IoCloseCircle } from "react-icons/io5";
import { Button, Checkbox, Col, Form, Input, Row, Select, Modal, message } from "antd";
import styles from "./ContactUs.module.scss";
import React, { useState, useEffect, useMemo } from "react";
import { FaMapMarkerAlt } from "react-icons/fa";
import { FiMail } from "react-icons/fi";
import axios from "../../config/axios";

const ContactUs = () => {
    const { form } = Form.useForm();
    const [agreed, setAgreed] = useState(false);
    const [loading, setLoading] = useState(false);

    //  wrap the initialization of 'options' in its own useMemo() Hook
    const options = useMemo(
        () => [
            {
                value: "product_quality",
                label: "Product quality",
            },
            {
                value: "new_products",
                label: "New products",
            },
            {
                value: "didnt_like",
                label: "Did not liked the product",
            },
            {
                value: "need_new",
                label: "Need a new product due to the defects in the received product",
            },
            {
                value: "damaged_product",
                label: "Damage in the received product ",
            },
            {
                value: "wrong_product",
                label: "Wrong item sent",
            },
            {
                value: "supplier_request",
                label: "Supplier request",
            },
            {
                value: "franchise_applicant",
                label: "Franchise applicant",
            },
            {
                value: "suggestion",
                label: "Suggestions",
            },
            {
                value: "other",
                label: "Other",
            },
        ],
        []
    );

    // final submit Function
    const handleSubmit = (values) => {
        setLoading(true);
        values.name = values.first_name + " " + values.last_name;

        axios.post("/contact-us/submit", values).then((response) => {
            message.success("Thanks for reaching us! We will get back to you soon.");
            setLoading(false);
        });

        form.resetFields();
        setLoading(false);
    };

    return (
        <>
            <section className={styles.contact_us + " container"}>
                <strong>Get in Touch</strong>

                <span style={{ fontSize: "1.5rem", fontWeight: 400, textAlign: "center" }}>
                    Reach out to us with your questions or feedback! Fill out the contact form on our website, and our friendly team will be
                    in touch with you shortly.
                </span>

                <Form
                    ref={form}
                    layout={"vertical"}
                    style={{ marginTop: "2rem", width: "100%" }}
                    onFinish={handleSubmit}
                    initialValues={{
                        remember: true,
                    }}
                >
                    <Row gutter={[15, 0]}>
                        <Col sm={8} xs={12}>
                            <Form.Item
                                name="title"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please select title",
                                    },
                                ]}
                            >
                                
                                <Select placeholder="Title">
                                    <Select.Option value={"Mr."}>Mr.</Select.Option>
                                    <Select.Option value={"Mrs."}>Mrs.</Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col sm={8} xs={12}></Col>
                        <Col sm={8} xs={12}>
                            <Form.Item
                                
                                name="first_name"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please enter your first name!",
                                    },
                                ]}
                            >
                                <Input placeholder="First Name" type={"text"} />
                            </Form.Item>
                        </Col>
                        <Col sm={8} xs={12}>
                            <Form.Item
                                
                                name="last_name"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please enter your last name!",
                                    },
                                ]}
                            >
                                <Input placeholder="Last Name" type={"text"} />
                            </Form.Item>
                        </Col>
                        <Col sm={8} xs={24}>
                            <Form.Item
                                
                                name="email"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please enter your email!",
                                    },
                                ]}
                            >
                                <Input placeholder="Email" type={"email"} />
                            </Form.Item>
                        </Col>
                        <Col lg={12} xs={24}>
                            <Form.Item name="phone_number" >
                                <Input
                                    placeholder="Phone Number (Optional)"
                                    addonBefore={
                                        <Form.Item name="phone_prefix" noStyle>
                                            <Select
                                                style={{
                                                    width: 70,
                                                }}
                                                defaultValue={"49"}
                                            >
                                                <Select.Option value="49">+49</Select.Option>
                                            </Select>
                                        </Form.Item>
                                    }
                                    style={{
                                        width: "100%",
                                    }}
                                />
                            </Form.Item>
                        </Col>
                        <Col sm={8} xs={24}>
                            <Form.Item  name={"subject"}>
                                <Select placeholder="Select your reason">
                                    {options.map((item, index) => (
                                        <Select.Option key={index} value={item.value}>
                                            {item.label}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col sm={24} xs={24}>
                            <Form.Item
                                
                                name="message"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please enter your message!",
                                    },
                                ]}
                            >
                                <Input.TextArea placeholder="Your Message" type={"text"} rows={6} />
                            </Form.Item>
                        </Col>
                        <Col sm={24} style={{ marginTop: "1rem" }}>
                            <Checkbox checked={agreed} onChange={(e) => setAgreed(e.target.checked)} style={{ marginBottom: "2rem" }}>
                                I consent to have my personal information processed in accordance with the Desi Fresh{" "}
                                <a href="/">Data Protection Policy</a> , as per EU GDPR regulations.
                            </Checkbox>
                        </Col>
                        <Col sm={24} xs={24} style={{ marginTop: "-1rem" }}>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    width: "100%",
                                }}
                            >
                                <Form.Item>
                                    <Button
                                        loading={loading}
                                        disabled={!agreed}
                                        htmlType="submit"
                                        style={{ padding: "0 4rem" }}
                                        type="primary"
                                    >
                                        Send Now
                                    </Button>
                                </Form.Item>
                            </div>
                        </Col>
                    </Row>
                </Form>

                <span
                    style={{
                        color: "var(--color-primary)",
                        fontSize: "2.8rem",
                        fontWeight: 700,
                        display: window.innerWidth <= 768 ? "none" : "block",
                    }}
                >
                    Want To Speak With Our Customer Support?
                </span>
                <ul>
                    <li>
                        <IoCallSharp size={20} color={"var(--color-primary)"} />
                        <div>
                            <span>Hotline (Mo. -Sa. 8 -20 Hrs.)</span>
                            <span>+49 - 8161 - 5193561</span>
                            <span>Monday - Friday 10:00 -20:00</span>
                        </div>
                    </li>
                    <li>
                        <FaMapMarkerAlt size={20} color={"var(--color-primary)"} />
                        <div>
                            <span>Königsteinstraße 1/3</span>
                            <span>80807 München Germany</span>
                            <span style={{ marginTop: 8 }}>Sonnenstraße 7a</span>
                            <span>85764 Oberschleißheim Germany</span>
                        </div>
                    </li>
                    <li>
                        <FiMail size={20} color={"var(--color-primary)"} />
                        <div>
                            <span
                                style={{
                                    color: "var(--color-primary)",
                                    textDecoration: "underline",
                                }}
                            >
                                support@dfresh.de
                            </span>
                        </div>
                    </li>
                </ul>
            </section>
        </>
    );
};

export default ContactUs;
